
<style type="text/css">
    .shell-page {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      background-color: #00000080; 
      height: 100vh;
    }
    .shell-page__spinner-container {
      box-shadow: 0 7px 25px #818181;
      padding: 15px 10px;
      width: max-content;
      height: max-content;
      max-width: 200px;
      max-height: 100px;
      background-color: #00000080;
    }
    .shell-page__shinner-label {
      margin-bottom: 15px;
      font-size: 16px;
    }
    .shell-page__spinner {
      width: 20px;
      height: 20px;
      box-sizing: border-box;
      border: 2px solid rgba(128,128,128,.3);
      border-left: 2px solid #19171c;
      border-radius: 50%;
      margin: 0 auto;
      -webkit-animation: loading-spinner 1750ms linear infinite;
      animation: loading-spinner 1750ms linear infinite;
    }
    @keyframes loading-spinner {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    body {
        animation: fadeInAnimation ease 3s;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;
    }



    @keyframes fadeInAnimation {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }
  </style>
  <div class="shell-page">
<!--     <div class="shell-page__spinner-container">
      <div class="shell-page__shinner-label">Loading. Please wait...</div>
      <div class="shell-page__spinner"></div>
    </div> -->
  </div>